import { useTranslation } from 'react-i18next';

export default function useRouteHistoryTableActions({
  setShowRouteDetailsModal,
  setSelectedRoute,
}) {
  const { t } = useTranslation(['table']);

  const actionHeader = t('actions', { ns: 'table' });

  const actions = [
    {
      label: t('routes.history.actions.details', { ns: 'table' }),
      onClick: (payload) => {
        setShowRouteDetailsModal(true);
        setSelectedRoute(payload);
      },
    },
  ];

  return { actions, actionHeader };
}
